import React, { Component } from 'react';
import { connect } from 'react-redux';

export default function asyncComponent(importComponent) {
  const mapStateToProps = state => ({
    isLoading: state.loader.isLoadingRoute,
    isDownloadingFile: state.loader.isDownloadingFile,
  });

  class AsyncComponent extends Component {
    constructor(props) {
      super(props);

      this.state = {
        component: null,
      };
    }

    componentWillMount() {
      const { dispatch, action, match } = this.props;

      if (action) {
        dispatch(action(match.params.id));
      }
    }

    async componentDidMount() {
      const { default: component } = await importComponent();

      this.setState({
        component,
      });
    }

    render() {
      if (this.props.isLoading) {
        return <div />;
      }
      const C = this.state.component;

      return C ? <C ref={el => (this.component = el)} {...this.props} /> : null;
    }
  }

  return connect(mapStateToProps, null, null, { withRef: true })(
    AsyncComponent
  );
}



// WEBPACK FOOTER //
// ./src/components/wrappers/async-component.js